import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Popconfirm, message, Modal, Row, Col, Button, } from 'antd';
import TableC from '../../basicElement/TableC';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import Filter from './PMFilter';
import Update from './PMUpdate';
import ExecuteSider from '../../execute/ExecuteSider';
import ExportUtil from '../../../common/ExportUtil';
import PMRefuse from './components/PMRefuse';
import UserSider from '../UserSider';
import PMReport from './components/PMReport';
import PMRefuseReson from './components/PMRefuseReson';
import { saveParams } from '../../../actions/noticeActions';

const TableOperation = (config) => {
    return (
        <div>
            {
                config.some(({ show = true }) => show === true) ?
                    (config || []).map((item, index) => {
                        const { key, name, callBack, show = true, disabled = false } = item;
                        return (
                            <a
                                key={key}
                                className='tableBtn'
                                disabled={disabled}
                                onClick={callBack}
                                style={{
                                    padding: 0,
                                    marginRight: 6,
                                    display: show ? 'inline-block' : 'none'
                                }}
                            >
                                {name}
                            </a>
                        )
                    }) :
                    <span>-</span>
            }
        </div>
    )
}
class RMTransfer extends Component {
    state = {
        loading: false,
        pagination: {
            current: 1,
            pageSize: 10,
        },
        dataList: [],
        searchParams: {},
        sortParams: {},
        visible: false,
        isMainUser: false
    }

    componentDidMount() {
        const { noticeParams, src } = this.props;
        src !== 'User' && src !== 'pmTransfer' && this.queryInvMainPm();
        this.setState(
            { searchParams: { handoverNum: noticeParams.handoverNum } },
            this.loadData)
    }


    componentWillUnmount() {
        this.props.saveParams({ handoverNum: undefined, type: undefined });
    }

    queryInvMainPm = () => {
        const options = {
            method: 'POST',
            url: API_URL.execute.queryInvMainPm,
            data: {},
            dataType: 'json',
            doneResult: (res) => {
                const pmUserId = res.data.userId;
                const { userId } = sessionStorage;
                this.setState({ isMainUser: pmUserId == userId })
            },
        };
        $.sendRequest(options);
    }


    export = () => {
        const { searchParams, pagination } = this.state;
        ExportUtil.export(searchParams, pagination, API_URL.execute.exportStaffHandover);
        message.success('正在下载中!')
    }

    loadData = () => {
        this.setState({ loading: true });
        const { sortParams, searchParams, pagination } = this.state;
        const { current, pageSize } = pagination;
        const options = {
            method: 'POST',
            url: API_URL.execute.queryStaffHandoverList,
            data: {
                ...searchParams,
                ...sortParams,
                offset: current,
                limit: pageSize,
            },
            dataType: 'json',
            doneResult: res => {
                const { datas, totalCount } = res;
                pagination.total = totalCount;
                this.setState({
                    loading: false,
                    dataList: datas,
                    pagination,
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }

    search = (params = {}) => {
        const { pagination } = this.state;
        pagination.current = 1;
        this.setState({
            pagination,
            searchParams: params,
        }, () => {
            this.loadData();
        });
    }

    handleDel = (record) => {
        const { staffHandoverId, createType } = record
        const options = {
            method: 'POST',
            url: API_URL.execute.delStaffHandover,
            data: { staffHandoverId, createType },
            dataType: 'json',
            doneResult: () => {
                this.loadData();
            },
        };
        $.sendRequest(options);
    }


    getColumns = () => {
        const columnNames = [];
        columnNames.push({
            title: '交接编号',
            dataIndex: 'handoverNum',
            key: 'handoverNum',
            width: 100,
            // sorter: true,
        }, {
            title: '项目编号',
            dataIndex: 'investigationCode',
            key: 'investigationCode',
            width: 120,
            // sorter: true,
        }, {
            title: '项目简称',
            dataIndex: 'investigationName',
            key: 'investigationName',
            width: 140,
        }, {
            title: '业务线',
            dataIndex: 'lineOfBusinessString',
            key: 'lineOfBusinessString',
            width: 80,
        }, {
            title: '执行业务线二级分类',
            dataIndex: 'secondLineName',
            key: 'secondLineName',
            width: 140,
        }, {
            title: '交接原因',
            dataIndex: 'handoverReason',
            key: 'handoverReason',
            width: 100,
        }, {
            title: '交接PM',
            dataIndex: 'handoverUserName',
            key: 'handoverUserName',
            width: 80,
        }, {
            title: '接收PM',
            dataIndex: 'receiveUserName',
            key: 'receiveUserName',
            width: 80,
        }, {
            title: '交接PM确认人',
            dataIndex: 'handoverConfirmUserName',
            key: 'handoverConfirmUserName',
            width: 80,
        }, {
            title: '接收PM确认人',
            dataIndex: 'receiveConfirmUserName',
            key: 'receiveConfirmUserName',
            width: 80,
        }, {
            title: '领域leader确认人',
            dataIndex: 'invAreaLeaderConfirmUserName',
            key: 'invAreaLeaderConfirmUserName',
            width: 100,
        }, {
            title: '交接状态',
            dataIndex: 'statusShow',
            key: 'statusShow',
            width: 80,
        }, {
            title: '操作',
            key: 'operation',
            fixed: 'right',
            width: 150,
            render: (text, record) => {
                const { staffHandoverId, canEdit, canDel, canWriteReport, status, canReadReport } = record;
                const config = [
                    {
                        key: 'edit',
                        name: '修改',
                        show: canEdit,
                        callBack: () => this.update(record, 'edit'),
                    },
                    {
                        key: 'del',
                        name: <Popconfirm title='确定要删除吗?' onConfirm={() => this.handleDel(record)} okText="确定" cancelText="取消">
                            <a>删除</a>
                        </Popconfirm>,
                        show: canDel,
                    },
                    {
                        key: 'writeReport',
                        name: '填写报告',
                        show: canWriteReport,
                        callBack: () => this.viewReport(record, true),
                    },
                    {
                        key: 'readReport',
                        name: '查看报告',
                        show: canReadReport,
                        callBack: () => this.viewReport(record),
                    },
                    {
                        key: 'reportReson',
                        name: '查看打回原因',
                        show: canWriteReport && status == 'REJECT',
                        callBack: () => this.reportReson(staffHandoverId),
                    },
                ]
                return TableOperation(config);
            }
        });
        return columnNames;
    }

    reload = (params = {}) => {
        const { pagination } = this.state;
        let offset;
        if (params.noPage) {
            offset = null;
        } else {
            offset = pagination.current;
        }
        this.loadData({
            offset: offset,
            ...params,
        });
    }

    viewReport = (record, isEdit) => {
        this.pmReportRef.show(record, isEdit);
    }

    update = (record, type) => {
        this.updateRef.show(record, type)
    }

    reportReson = (id) => {
        this.pmReportResonRef.show(id);
    }

    handleTableChange = (params) => {
        this.setState({
            ...params,
        }, () => {
            this.loadData();
        });
    }

    render() {
        const { src } = this.props;
        const { loading, dataList, pagination, sortParams, searchParams, isMainUser } = this.state;
        const yscroll = dataList.length > 0 ? document.documentElement.clientHeight - 410 : false;
        return (
            src === "pmTransfer" ?
                <div className="content">
                    <UserSider selectKey='pmTransfer' openKeys={['sub1']} />
                    <div className="main">
                        <Filter
                            search={this.search}
                            update={this.update}
                            export={this.export}
                            searchParams={searchParams}
                            src={src}
                            isMainUser={isMainUser}
                        />
                        <TableC
                            columns={this.getColumns()}
                            data={dataList}
                            loading={loading}
                            scrollY={yscroll}
                            sortParams={sortParams}
                            onChange={this.handleTableChange}
                            pagination={pagination}
                            rowKey="requirementId"
                        />
                        <Update
                            src={src}
                            ref={el => { this.updateRef = el; }}
                            reload={this.reload}
                        />
                        <PMReport
                            ref={el => { this.pmReportRef = el; }}
                            reload={this.reload}
                        />
                        <PMRefuseReson
                            ref={el => { this.pmReportResonRef = el; }}
                            reload={this.reload}
                        />
                    </div>
                </div> :
                <div>
                    <Filter
                        search={this.search}
                        update={this.update}
                        export={this.export}
                        searchParams={searchParams}
                        src={src}
                        isMainUser={isMainUser}
                    />
                    <TableC
                        columns={this.getColumns()}
                        data={dataList}
                        loading={loading}
                        scrollY={yscroll}
                        sortParams={sortParams}
                        onChange={this.handleTableChange}
                        pagination={pagination}
                        rowKey="requirementId"
                    />
                    <Update
                        src={src}
                        ref={el => { this.updateRef = el; }}
                        reload={this.reload}
                    />
                    <PMReport
                        ref={el => { this.pmReportRef = el; }}
                        reload={this.reload}
                    />
                    <PMRefuseReson
                        ref={el => { this.pmReportResonRef = el; }}
                        reload={this.reload}
                    />
                </div>
        );
    }
}

const mapStateToProps = function (store) {
    return {
        noticeParams: store.noticeState.params,
        searchParams: store.executeState.searchParams,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        saveParams: (params) => dispatch(saveParams(params)),
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(RMTransfer);



// WEBPACK FOOTER //
// ./src/components/user/transfer/RMTransfer.js